import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthContext } from './hooks/useAuthContext'

// pages and components
import Home from './pages/Home'
import Admin from './pages/Admin'
import Login from './pages/Login'
import History from './pages/History'
import Payment from './pages/Payment'
import Header from './components/Header'

function App() {

  const { user } = useAuthContext()

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <div className='pages'>
          <Routes>
            <Route path="/" element={user && user.isAdmin ? <Admin /> : user && !user.firstLogin ? <Home /> : user && user.firstLogin ? <Navigate to='/reset' /> : <Navigate to='/login' /> }/>
            <Route path="/admin" element={user && user.isAdmin ? <Admin /> : <Navigate to='/login' /> }/>
            <Route path="/login" element={!user ? <Login /> : user && user.isAdmin ? <Navigate to='/admin' /> : <Navigate to='/' />} />
            <Route path="/history" element={user ? <History /> : <Navigate to='/' />} />
            <Route path="/payment" element={user ? <Payment /> : <Navigate to='/' />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
